const experience = {
  en: {
    lang: "en",
    title: "Experience & Education",
    experienceTitle: "Work Experience",
    educationTitle: "Education",
    experienceItems: [
      {
        title: "Consultant",
        company: "Bouvet Norge AS",
        date: "Jul 2024 - Present",
        role: "Consultant",
        description:
          "Working as a consultant delivering high-quality solutions to clients. Specializing in backend development and system architecture.",
        projects: [
          {
            client: "DNV",
            period: "May 2025 - Aug 2025",
            role: "Software Engineer",
            description:
              "Translation of an open source SDK to Python, focusing on optimization and integration with existing systems.",
            technologies: [
              "Python",
              "Docker",
              "Dev Containers",
              "PyTest",
              "Azure",
              "Azure DevOps",
              "GitHub",
            ],
          },
          {
            client: "Å Insite",
            period: "Aug 2024 - Apr 2025",
            role: "Data Engineer & Customer Support",
            description:
              "Development and maintenance of digital services for Å Insite. Focus on Python, PostgreSQL, and DevOps practices.",
            technologies: [
              "Python",
              "PostgreSQL",
              "Docker",
              "Dev Containers",
              "Grafana",
              "Pandas",
              "Azure",
              "Azure DevOps",
              "HubSpot",
              "Jira",
            ],
          },
        ],
      },
      {
        title: "Software Engineer",
        company: "DNB ASA",
        date: "Jan 2022 - Jul 2024",
        role: "Software Engineer",
        description:
          "Responsible for development and maintenance of critical banking systems. Worked with Java backend development, system architecture, and enterprise solutions. Led technical specification work and contributed to knowledge sharing within teams.",
        projects: [
          {
            client: "DNB Payments",
            period: "Jan 2022 - Jul 2024",
            role: "Backend Developer",
            description:
              "Development of critical trading solutions for DNB Payments. Focus on performance, stability, and scalability.",
            technologies: [
              "Java",
              "Spring Boot",
              "Maven",
              "IBM DB2",
              "JavaScript",
              "Docker",
              "Grafana",
              "Jenkins",
              "Azure",
              "Azure DevOps",
              "AWS",
              "Confluence",
              "Postman",
              "GitHub",
              "GitLab",
              "Bitbucket",
              "Jira",
            ],
          },
          {
            client: "DNB Tech & Thrive",
            period: "Aug 2023 - Jul 2024",
            role: "Community Lead",
            description:
              "Co-founder and community lead for DNB Tech & Thrive, a community focused on technology and innovation within DNB. Organizing events, workshops, and knowledge sharing sessions.",
            technologies: [],
          },
          {
            client: "DNB Payments",
            period: "Jan 2023 - Jul 2024",
            role: "License Manager",
            description:
              "Managed software licenses and compliance for DNB Payments. Ensured proper usage and optimization of software resources.",
            technologies: [
              "Basware",
              "License Management",
              "Compliance",
              "Coupa",
            ],
          },
        ],
      },
      {
        title: "Owner and Founder",
        company: "Michael Ekornrud",
        date: "May 2021 - Present",
        role: "Owner and Founder",
        description:
          "Founded and managing a technology consulting company focused on delivering custom software solutions and technical expertise to clients. Specializing in system development and technical architecture.",
        projects: [
          {
            client: "Takstsenteret AS",
            period: "Sep 2023 - Present",
            role: "Web Developer & IT Support",
            description:
              "Maintenance and development of the company's website, including SEO optimization and technical support for users and employees.",
            technologies: ["Wordpress", "SEO", "HTML", "CSS", "PHP", "Captcha"],
          },
          {
            client: "Michael Ekornrud",
            period: "Sep 2025",
            role: "Web Developer",
            description:
              "Development of a personal website to showcase projects and experience. Focus on modern web technologies and responsive design.",
            technologies: [
              "React",
              "JavaScript",
              "Node.js",
              "npm",
              "CSS",
              "HTML",
              "GitHub Actions",
              "EsLint",
              "Prettier",
            ],
          },
        ],
      },
    ],
    educationItems: [
      {
        title: "Bachelor in Software Engineering",
        company: "OsloMet",
        date: "Aug 2019 - Jun 2022",
      },
      {
        title: "Pre-engineering Course",
        company: "NTNU - Norwegian University of Science and Technology",
        date: "Aug 2018 - Jun 2019",
      },
    ],
  },
  no: {
    lang: "no",
    title: "Erfaring & Utdanning",
    experienceTitle: "Arbeidserfaring",
    educationTitle: "Utdanning",
    experienceItems: [
      {
        title: "Konsulent",
        company: "Bouvet Norge AS",
        date: "Jul 2024 - Nå",
        role: "Konsulent",
        description:
          "Jobber som konsulent med å levere løsninger av høy kvalitet til kunder. Spesialiserer meg innen backend-utvikling og systemarkitektur.",
        projects: [
          {
            client: "DNV",
            period: "Mai 2025 - Aug 2025",
            role: "Software Engineer",
            description:
              "Oversettelse av et open source SDK til Python, med fokus på optimalisering og integrasjon med eksisterende systemer.",
            technologies: [
              "Python",
              "Docker",
              "Dev Containers",
              "PyTest",
              "Azure",
              "Azure DevOps",
              "GitHub",
            ],
          },
          {
            client: "Å Insite",
            period: "Aug 2024 - April 2025",
            role: "Data Engineer & Kundestøtte",
            description:
              "Utvikling og vedlikehold av digitale tjenester for Å Insite. Fokus på Python, PostgreSQL og DevOps-praksis.",
            technologies: [
              "Python",
              "PostgreSQL",
              "Docker",
              "Dev Containers",
              "Grafana",
              "Pandas",
              "Azure",
              "Azure DevOps",
              "HubSpot",
              "Jira",
            ],
          },
        ],
      },
      {
        title: "Software Engineer",
        company: "DNB ASA",
        date: "Jan 2022 - Jul 2024",
        role: "Software Engineer",
        description:
          "Ansvarlig for utvikling og vedlikehold av kritiske banksystemer. Jobbet med Java backend-utvikling, systemarkitektur og enterprise-løsninger. Ledet teknisk spesifikasjonsarbeid og bidro til kunnskapsdeling i teamene.",
        projects: [
          {
            client: "DNB Payments",
            period: "Jan 2022 - Jul 2024",
            role: "Backend-utvikler",
            description:
              "Utvikling av kritiske betalingsløsninger for DNB Payments. Fokus på ytelse, stabilitet og skalerbarhet.",
            technologies: [
              "Java",
              "Spring Boot",
              "Maven",
              "IBM DB2",
              "JavaScript",
              "Docker",
              "Grafana",
              "Jenkins",
              "Azure",
              "Azure DevOps",
              "AWS",
              "Confluence",
              "Postman",
              "GitHub",
              "GitLab",
              "Bitbucket",
              "Jira",
            ],
          },
          {
            client: "DNB Tech & Thrive",
            period: "Aug 2023 - Jul 2024",
            role: "Community Lead",
            description:
              "Medgrunnlegger og community lead for DNB Tech & Thrive, et fellesskap fokusert på teknologi og innovasjon i DNB. Organisering av arrangementer, workshops og kunnskapsdelingssesjoner.",
            technologies: [],
          },
          {
            client: "DNB Payments",
            period: "Jan 2023 - Jul 2024",
            role: "Lisensansvarlig",
            description:
              "Administrerte programvarelisenser og etterlevelse for DNB Payments. Sikret riktig bruk og optimalisering av programvareressurser.",
            technologies: [
              "Basware",
              "License Management",
              "Compliance",
              "Coupa",
            ],
          },
        ],
      },
      {
        title: "Eier og Grunnlegger",
        company: "Michael Ekornrud",
        date: "Mai 2021 - Nå",
        role: "Eier og Grunnlegger",
        description:
          "Grunnla og driver et teknologikonsulentselskap som fokuserer på å levere skreddersydde programvareløsninger og teknisk ekspertise til kunder. Spesialiserer seg innen systemutvikling og teknisk arkitektur.",
        projects: [
          {
            client: "Takstsenteret AS",
            period: "Sep 2023 - Nå",
            role: "Webutvikler & IT-støtte",
            description:
              "Vedlikehold og utvikling av selskapets nettside, inkludert SEO-optimalisering og teknisk støtte for brukere og ansatte.",
            technologies: ["Wordpress", "SEO", "HTML", "CSS", "PHP", "Captcha"],
          },
          {
            client: "Michael Ekornrud",
            period: "Sep 2025",
            role: "Webutvikler",
            description:
              "Utvikling av en personlig nettside for å vise frem prosjekter og erfaring. Fokus på moderne webteknologier og responsivt design.",
            technologies: [
              "React",
              "JavaScript",
              "Node.js",
              "npm",
              "CSS",
              "HTML",
              "GitHub Actions",
              "EsLint",
              "Prettier",
            ],
          },
        ],
      },
    ],
    educationItems: [
      {
        title: "Bachelor i Dataingeniør",
        company: "OsloMet",
        date: "Aug 2019 - Jun 2022",
      },
      {
        title: "Forkurs for Ingeniør- og Sivilingeniørutdanning",
        company: "NTNU - Norges Teknisk-Naturvitenskapelige Universitet",
        date: "Aug 2018 - Jun 2019",
      },
    ],
  },
};

export default experience;
